import { render, staticRenderFns } from "./PageReportGoodsSelfIncome.vue?vue&type=template&id=ef37e52c&scoped=true"
import script from "./PageReportGoodsSelfIncome.vue?vue&type=script&lang=js"
export * from "./PageReportGoodsSelfIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef37e52c",
  null
  
)

export default component.exports